import React, { Component } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Select from "react-select";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

// Server-side paginated + filtered + sorted OMR history.
const GET_OMR_PAGED = gql`
  query (
    $institute_id: Int, $page: Int, $pageSize: Int, $search: String,
    $sortField: String, $sortOrder: String,
    $examType: String, $class: String, $section: String, $status: String,
    $fromDate: String, $toDate: String
  ) {
    getOMRExamResultsPaged(
      institute_id: $institute_id, page: $page, pageSize: $pageSize, search: $search,
      sortField: $sortField, sortOrder: $sortOrder,
      examType: $examType, class: $class, section: $section, status: $status,
      fromDate: $fromDate, toDate: $toDate
    ) {
      totalCount
      rows {
        exam_paper_id exam_name exam class section
        total_omr processing_omr updated_omr rejected_omr pending_omr start_time
      }
    }
  }
`;

// Distinct filter values across ALL data (loaded once for dropdown options).
const GET_OMR_ALL = gql`
  query ($institute_id: Int!) {
    getOMRExamResults(institute_id: $institute_id) { exam class section }
  }
`;

const SELECT_STYLES = {
  control: (base, s) => ({
    ...base, minHeight: 42, borderRadius: 8,
    borderColor: s.isFocused ? "#7c3aed" : "#e3dbf7",
    boxShadow: s.isFocused ? "0 0 0 2px rgba(124,58,237,.15)" : "none",
    "&:hover": { borderColor: "#7c3aed" }, fontSize: 13.5,
  }),
  option: (base, s) => ({
    ...base, fontSize: 13.5,
    background: s.isSelected ? "#7c3aed" : s.isFocused ? "#f5f3ff" : "#fff",
    color: s.isSelected ? "#fff" : "#374151",
  }),
  singleValue: (base) => ({ ...base, color: "#4c1d95", fontWeight: 600 }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

class NewOmrHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      totalCount: 0,
      loading: true,
      page: 1,
      pageSize: 10,
      sortField: "date",
      sortOrder: "desc",
      search: "",
      // filters
      fExamType: "", fClass: "", fSection: "", fStatus: "", fFrom: "", fTo: "",
      // dropdown options
      examTypes: [], classes: [], sections: [],
    };
    this._searchTimer = null;
  }

  componentDidMount() {
    this.loadFilterOptions();
    this.fetchPage();
  }

  inst = () => parseInt(Cookies.get("institutionid")) || 0;

  // Load distinct exam/class/section values for the filter dropdowns (once).
  loadFilterOptions = async () => {
    try {
      const res = await this.props.client.query({
        query: GET_OMR_ALL,
        variables: { institute_id: this.inst() },
        fetchPolicy: "network-only",
      });
      const data = (res.data && res.data.getOMRExamResults) || [];
      const set = (field, split) => {
        const s = new Set();
        data.forEach((d) => {
          const v = d[field];
          if (v == null || v === "") return;
          if (split) String(v).split(",").forEach((x) => x.trim() && s.add(x.trim()));
          else s.add(String(v).trim());
        });
        return [...s].sort();
      };
      this.setState({
        examTypes: set("exam"), classes: set("class"), sections: set("section", true),
      });
    } catch (_) { /* non-fatal */ }
  };

  fetchPage = async () => {
    const s = this.state;
    this.setState({ loading: true });
    try {
      const res = await this.props.client.query({
        query: GET_OMR_PAGED,
        variables: {
          institute_id: this.inst(),
          page: s.page, pageSize: s.pageSize,
          search: s.search || null,
          sortField: s.sortField, sortOrder: s.sortOrder,
          examType: s.fExamType || null, class: s.fClass || null,
          section: s.fSection || null, status: s.fStatus || null,
          fromDate: s.fFrom ? String(moment(s.fFrom, "YYYY-MM-DD").startOf("day").unix()) : null,
          toDate: s.fTo ? String(moment(s.fTo, "YYYY-MM-DD").endOf("day").unix()) : null,
        },
        fetchPolicy: "network-only",
      });
      const d = (res.data && res.data.getOMRExamResultsPaged) || { rows: [], totalCount: 0 };
      this.setState({ rows: d.rows || [], totalCount: d.totalCount || 0, loading: false });
    } catch (e) {
      this.setState({ rows: [], totalCount: 0, loading: false });
    }
  };

  // react-bootstrap-table remote change (page / sizePerPage / sort)
  handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
    const next = {};
    if (type === "pagination") { next.page = page; next.pageSize = sizePerPage; }
    if (type === "sort") { next.sortField = sortField; next.sortOrder = sortOrder; next.page = 1; }
    this.setState(next, this.fetchPage);
  };

  onSearch = (v) => {
    this.setState({ search: v });
    clearTimeout(this._searchTimer);
    this._searchTimer = setTimeout(() => this.setState({ page: 1 }, this.fetchPage), 350);
  };

  setFilter = (patch) => this.setState({ ...patch, page: 1 }, this.fetchPage);

  clearFilters = () =>
    this.setState(
      { fExamType: "", fClass: "", fSection: "", fStatus: "", fFrom: "", fTo: "", search: "", page: 1 },
      this.fetchPage,
    );

  columns = [
    { dataField: "sno", text: "S.No", sort: false,
      formatter: (c, r, i) => (this.state.page - 1) * this.state.pageSize + i + 1 },
    { dataField: "date", text: "Exam Date", sort: true,
      formatter: (c, r) => (r.start_time ? moment.unix(r.start_time).format("DD/MM/YYYY") : "-") },
    { dataField: "exam_name", text: "Exam Name", sort: true },
    { dataField: "exam", text: "Exam Type", sort: true },
    { dataField: "class", text: "Class", sort: true },
    { dataField: "section", text: "Sections", sort: true },
    { dataField: "total_omr", text: "Total Uploaded", sort: true },
    { dataField: "processing_omr", text: "In-Process", sort: true },
    { dataField: "updated_omr", text: "Updated", sort: true },
    { dataField: "rejected_omr", text: "Error", sort: true,
      formatter: (c) => <span style={{ color: Number(c) > 0 ? "#dc2626" : "#16a34a", fontWeight: 700 }}>{c}</span> },
    { dataField: "view", text: "Details", sort: false,
      formatter: (c, r) => (
        <Button variant="link" className="text-theme"
          onClick={() => this.props.history.push(`/offline_exams/omr/status/${r.exam_paper_id}`)}>
          <i className="fa fa-eye text-dark" />
        </Button>
      ) },
  ];

  renderFilters() {
    const { fExamType, fClass, fSection, fStatus, fFrom, fTo, examTypes, classes, sections } = this.state;
    const lbl = { display: "block", fontSize: 11, fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: ".5px", marginBottom: 6 };
    const dateInput = { width: "100%", height: 42, borderRadius: 8, border: "1.5px solid #e3dbf7", color: "#4c1d95", fontWeight: 600, background: "#fff", padding: "0 12px", fontSize: 13.5 };
    const opts = (arr) => [{ value: "", label: "All" }, ...arr.map((v) => ({ value: v, label: v }))];
    const val = (arr, v) => opts(arr).find((o) => o.value === v) || opts(arr)[0];
    const statusOpts = [
      { value: "", label: "All" }, { value: "error", label: "Has errors" },
      { value: "processing", label: "In process" }, { value: "done", label: "Completed" },
    ];
    const anyFilter = fExamType || fClass || fSection || fStatus || fFrom || fTo || this.state.search;
    const portal = typeof document !== "undefined" ? document.body : null;
    return (
      <div style={{ background: "#faf8ff", border: "1px solid #ece7f9", borderRadius: 12, padding: "16px 18px", marginBottom: 16 }}>
        <Row className="g-3">
          <Col xl md={4} sm={6} className="mb-2 mb-xl-0">
            <label style={lbl}>Exam Type</label>
            <Select styles={SELECT_STYLES} isSearchable={false} menuPortalTarget={portal}
              options={opts(examTypes)} value={val(examTypes, fExamType)}
              onChange={(o) => this.setFilter({ fExamType: o.value })} />
          </Col>
          <Col xl md={4} sm={6} className="mb-2 mb-xl-0">
            <label style={lbl}>Class</label>
            <Select styles={SELECT_STYLES} isSearchable={false} menuPortalTarget={portal}
              options={opts(classes)} value={val(classes, fClass)}
              onChange={(o) => this.setFilter({ fClass: o.value })} />
          </Col>
          <Col xl md={4} sm={6} className="mb-2 mb-xl-0">
            <label style={lbl}>Section</label>
            <Select styles={SELECT_STYLES} menuPortalTarget={portal}
              options={opts(sections)} value={val(sections, fSection)}
              onChange={(o) => this.setFilter({ fSection: o.value })} />
          </Col>
          <Col xl md={4} sm={6} className="mb-2 mb-xl-0">
            <label style={lbl}>Status</label>
            <Select styles={SELECT_STYLES} isSearchable={false} menuPortalTarget={portal}
              options={statusOpts} value={statusOpts.find((o) => o.value === fStatus)}
              onChange={(o) => this.setFilter({ fStatus: o.value })} />
          </Col>
          <Col xl md={4} sm={6} className="mb-2 mb-xl-0">
            <label style={lbl}>From</label>
            <input type="date" style={dateInput} value={fFrom} onChange={(e) => this.setFilter({ fFrom: e.target.value })} />
          </Col>
          <Col xl md={4} sm={6} className="mb-2 mb-xl-0">
            <label style={lbl}>To</label>
            <input type="date" style={dateInput} value={fTo} onChange={(e) => this.setFilter({ fTo: e.target.value })} />
          </Col>
        </Row>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 12, flexWrap: "wrap" }}>
          <input
            placeholder="🔍 Search exam / class / section…"
            value={this.state.search}
            onChange={(e) => this.onSearch(e.target.value)}
            style={{ height: 40, borderRadius: 8, border: "1.5px solid #e3dbf7", padding: "0 14px", fontSize: 13.5, minWidth: 260, flex: "0 0 auto" }}
          />
          {anyFilter ? (
            <Button variant="link" style={{ padding: 0, color: "#7c3aed", fontWeight: 600, fontSize: 13 }} onClick={this.clearFilters}>
              <i className="fas fa-times mr-1" />Clear filters
            </Button>
          ) : null}
        </div>
      </div>
    );
  }

  render() {
    const { rows, totalCount, loading, page, pageSize } = this.state;
    return (
      <Container fluid style={{ background: "#ffffff", maxWidth: "100%", padding: 0 }}>
        {this.renderFilters()}
        {loading ? (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "40vh", gap: 12 }}>
            <div className="spinner-border" style={{ color: "#7c3aed", width: 40, height: 40 }} role="status" />
            <div style={{ color: "#7c3aed", fontWeight: 600 }}>Loading upload history…</div>
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <BootstrapTable
              remote
              keyField="exam_paper_id"
              data={rows}
              columns={this.columns}
              onTableChange={this.handleTableChange}
              pagination={paginationFactory({
                page, sizePerPage: pageSize, totalSize: totalCount,
                sizePerPageList: [10, 25, 50, 100],
                showTotal: true,
                paginationTotalRenderer: (from, to, size) => (
                  <span className="ml-2 react-bootstrap-table-pagination-total">
                    Showing {from} to {to} of {size} Results
                  </span>
                ),
              })}
              noDataIndication={() => (
                <div style={{ padding: 30, textAlign: "center", color: "#94a3b8" }}>
                  No OMR uploads match your filters.
                </div>
              )}
              bordered={false}
              hover
              wrapperClasses="table-responsive"
            />
          </div>
        )}
      </Container>
    );
  }
}

export default withRouter(withApollo(NewOmrHistory));
